module.exports = __webpack_public_path__ + "images/football1-95bdbdaec921f0dd1936c12246f0c748.jpg";